{
  "AdminControl_PolicyApplied": "Policy Applied",
  "AdminControl_RecordingPolicyDetails": "Recording Policy Details",
  "AdminControl_DisplayName": "Display Name:",
  "AdminControl_UserPrincipalName": "User Principal Name",
  "AdminControl_TeamsComplianceRecordingPolicy": "Teams Compliance Recording Policy",
  "AdminControl_PresenceStatus": "Presence Status",
  "AdminControl_CopiedToClipboard": "Copied to clipboard",
  "AdminControl_ResponseSuccess": "Task completed successfully",
  "NAME": "AdminControlLanguage"
}